function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  d: "M178.672,393.061c88.364,0,160.595-70.4,163.546-158.061H15.126C18.077,322.659,90.308,393.061,178.672,393.061ZM94.822,329.279a5.579,5.579,0,1,1-5.579,5.579A5.579,5.579,0,0,1,94.822,329.279ZM72.507,306.964a5.579,5.579,0,1,1-5.579,5.579A5.579,5.579,0,0,1,72.507,306.964Z",
  transform: "translate(-3.875 -65.781)",
  fill: "#65ccb8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  d: "M334.33,169.4a16.816,16.816,0,0,0-7.422-8.927,5.579,5.579,0,0,1-1.155-8.779,16.73,16.73,0,0,0-7.509-28.02,5.578,5.578,0,0,1-3.387-8.18,16.73,16.73,0,0,0-14.5-25.122,5.578,5.578,0,0,1-5.4-7.025,16.732,16.732,0,0,0-20.514-20.514,5.579,5.579,0,0,1-7.024-5.39,16.73,16.73,0,0,0-25.122-14.5,5.579,5.579,0,0,1-8.181-3.388A16.73,16.73,0,0,0,206.1,32.048a5.579,5.579,0,0,1-8.779-1.156,16.731,16.731,0,0,0-29.01,0,5.579,5.579,0,0,1-8.779,1.156,16.73,16.73,0,0,0-28.022,7.507,5.579,5.579,0,0,1-8.181,3.388,16.73,16.73,0,0,0-25.122,14.5,5.579,5.579,0,0,1-7.024,5.39A16.731,16.731,0,0,0,70.672,83.352a5.578,5.578,0,0,1-5.387,7.025A16.73,16.73,0,0,0,50.778,115.5a5.578,5.578,0,0,1-3.387,8.18,16.73,16.73,0,0,0-7.509,28.02,5.579,5.579,0,0,1-1.155,8.779A16.816,16.816,0,0,0,31.3,169.4Zm-77.674-56.158a5.579,5.579,0,1,1-5.579,5.579A5.579,5.579,0,0,1,256.656,113.246ZM107.892,90.931a5.579,5.579,0,1,1-5.579,5.579A5.579,5.579,0,0,1,107.892,90.931Zm0,44.629a5.579,5.579,0,1,1-5.579,5.579A5.579,5.579,0,0,1,107.892,135.56ZM85.578,113.246A5.579,5.579,0,1,1,80,118.824,5.579,5.579,0,0,1,85.578,113.246Z",
  transform: "translate(-8.02 -11.343)",
  fill: "#65ccb8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_66",
  "data-name": "Path 66",
  d: "M349.595,171.14a5.578,5.578,0,0,0-5.579-5.579h-6.151a28.058,28.058,0,0,0-8.288-14.8A27.861,27.861,0,0,0,319.029,111.4,27.862,27.862,0,0,0,298.652,76.1a27.862,27.862,0,0,0-28.818-28.818A27.862,27.862,0,0,0,234.54,26.907a27.861,27.861,0,0,0-39.365-10.548,27.865,27.865,0,0,0-40.755,0,27.861,27.861,0,0,0-39.365,10.548A27.862,27.862,0,0,0,79.76,47.286,27.861,27.861,0,0,0,50.943,76.1,27.862,27.862,0,0,0,30.566,111.4a27.861,27.861,0,0,0-10.548,39.365,28.053,28.053,0,0,0-8.288,14.8H5.579A5.578,5.578,0,0,0,0,171.141a175.114,175.114,0,0,0,113.115,163.64h-3.4a5.579,5.579,0,1,0,0,11.157H239.881a5.579,5.579,0,0,0,0-11.157h-3.4A175.114,175.114,0,0,0,349.595,171.14ZM30.707,156.635a5.579,5.579,0,0,0,1.155-8.779,16.73,16.73,0,0,1,7.509-28.02,5.578,5.578,0,0,0,3.387-8.18,16.73,16.73,0,0,1,14.5-25.122,5.578,5.578,0,0,0,5.4-7.025A16.731,16.731,0,0,1,83.166,59a5.579,5.579,0,0,0,7.024-5.39,16.73,16.73,0,0,1,25.122-14.5,5.579,5.579,0,0,0,8.181-3.388A16.73,16.73,0,0,1,151.514,28.2a5.579,5.579,0,0,0,8.779-1.156,16.731,16.731,0,0,1,29.009,0A5.579,5.579,0,0,0,198.08,28.2,16.73,16.73,0,0,1,226.1,35.712a5.579,5.579,0,0,0,8.181,3.388A16.73,16.73,0,0,1,259.4,53.6,5.579,5.579,0,0,0,266.428,59a16.732,16.732,0,0,1,20.514,20.514,5.578,5.578,0,0,0,5.387,7.025,16.73,16.73,0,0,1,14.507,25.122,5.578,5.578,0,0,0,3.387,8.18,16.73,16.73,0,0,1,7.509,28.02,5.579,5.579,0,0,0,1.155,8.779,16.816,16.816,0,0,1,7.422,8.927H23.284A16.82,16.82,0,0,1,30.707,156.635Zm307.637,20.084C335.392,264.378,263.161,334.78,174.8,334.78S14.2,264.378,11.251,176.719Z",
  transform: "translate(0 -7.5)",
  fill: "#65ccb8"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_44",
  "data-name": "Ellipse 44",
  cx: 5.579,
  cy: 5.579,
  r: 5.579,
  transform: "translate(85.371 263.498)",
  fill: "#65ccb8"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_45",
  "data-name": "Ellipse 45",
  cx: 5.579,
  cy: 5.579,
  r: 5.579,
  transform: "translate(63.056 241.183)",
  fill: "#65ccb8"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_46",
  "data-name": "Ellipse 46",
  cx: 5.579,
  cy: 5.579,
  r: 5.579,
  transform: "translate(94.297 124.218)",
  fill: "#65ccb8"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_47",
  "data-name": "Ellipse 47",
  cx: 5.579,
  cy: 5.579,
  r: 5.579,
  transform: "translate(71.982 101.903)",
  fill: "#65ccb8"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_48",
  "data-name": "Ellipse 48",
  cx: 5.579,
  cy: 5.579,
  r: 5.579,
  transform: "translate(243.06 101.903)",
  fill: "#65ccb8"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_49",
  "data-name": "Ellipse 49",
  cx: 5.579,
  cy: 5.579,
  r: 5.579,
  transform: "translate(94.297 79.589)",
  fill: "#65ccb8"
});

function SvgRiceselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "riceselected",
    xmlns: "http://www.w3.org/2000/svg",
    width: 349.595,
    height: 338.439,
    viewBox: "0 0 349.595 338.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiceselected);
export default __webpack_public_path__ + "static/media/riceselected.1d2e78d4.svg";
export { ForwardRef as ReactComponent };